import { AlertCircle } from 'lucide-react'

interface ChartErrorStateProps {
  message?: string
  error?: string
}

export function ChartErrorState({
  message = 'Failed to load chart data',
  error,
}: ChartErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[250px] text-muted-foreground">
      <AlertCircle className="h-8 w-8 text-destructive mb-3" />
      <p className="text-sm font-medium text-destructive">{message}</p>
      {error && <p className="text-xs mt-2">{error}</p>}
    </div>
  )
}
